import { Field, NumberInput, SectionCard, TextArea, TextInput, Toggle } from './fields';
import type { SectionProps } from './types';

export function PricingSection({ doc, onChange, disabled }: SectionProps) {
  const discount = doc.discount ?? null;

  return (
    <SectionCard title="Pricing extras">
      <div className="space-y-2.5">
        <Toggle
          checked={discount !== null}
          onChange={(checked) => onChange((d) => ({ ...d, discount: checked ? { label: '', percentage: 10 } : null }))}
          label="Apply a discount"
          disabled={disabled}
        />
        {discount && (
          <div className="grid grid-cols-1 gap-3 rounded-xl border border-line bg-paper p-4 sm:grid-cols-[2fr_1fr]">
            <Field label="Label" hint="e.g. 'Book before August'.">
              <TextInput
                value={discount.label}
                onChange={(e) => onChange((d) => ({ ...d, discount: { ...(d.discount ?? { label: '', percentage: 10 }), label: e.target.value } }))}
                disabled={disabled}
              />
            </Field>
            <Field label="Percentage">
              <NumberInput
                min={1}
                max={100}
                value={discount.percentage}
                onChange={(value) =>
                  onChange((d) => ({
                    ...d,
                    discount: { ...(d.discount ?? { label: '', percentage: 10 }), percentage: value === '' ? 1 : value },
                  }))
                }
                disabled={disabled}
              />
            </Field>
          </div>
        )}
      </div>

      <Field label="Investment subtitle" hint="Optional. Leave blank for the default subtitle above the pricing grid.">
        <TextInput
          value={doc.investment_subtitle ?? ''}
          onChange={(e) => onChange((d) => ({ ...d, investment_subtitle: e.target.value }))}
          disabled={disabled}
        />
      </Field>
    </SectionCard>
  );
}

export function TermsSection({ doc, onChange, disabled }: SectionProps) {
  return (
    <SectionCard title="Terms">
      <Field label="Deposit" hint="Free text. The deposit percentage is parsed from this for the add-on configurator.">
        <TextArea
          rows={2}
          value={doc.terms?.deposit ?? ''}
          onChange={(e) => onChange((d) => ({ ...d, terms: { ...d.terms, deposit: e.target.value } }))}
          disabled={disabled}
        />
      </Field>
      <Field label="Revisions" hint="Free text. The round count is parsed from this for the default timeline entry.">
        <TextArea
          rows={2}
          value={doc.terms?.revisions ?? ''}
          onChange={(e) => onChange((d) => ({ ...d, terms: { ...d.terms, revisions: e.target.value } }))}
          disabled={disabled}
        />
      </Field>
    </SectionCard>
  );
}
